import { useMemo } from 'react';
import classNames from 'classnames';

import { isLimitErrorCode, isUserLimitErrorCode } from '../../../utils/rewards';
import { formatExpirationDate, isPastDate, isSoonDate } from '../../../utils/dates';
import './Flag.scss';
import { formatReadableNumber } from '../../../utils/numbers';

/* Parent element MUST have 'position: relative' */

const Flag = ({
  status,
  isNew,
  isFreeReward,
  hasRewardCodes,
  exchangeValue,
  expireAt,
  allowTcCredits,
  tcCreditAmount,
  tcCreditAmountType,
  properties,
  appliesMultiplier,
}) => {
  const {
    label,
    style,
  } = useMemo(() => {
    switch (true) {
      case isLimitErrorCode(status):
        return {
          label: properties?.soldOut?.label || 'SOLD_OUT',
          style: properties?.soldOut?.style || {},
        };
      case (isUserLimitErrorCode(status) || hasRewardCodes):
        return {
          label: properties?.claimed?.label || 'CLAIMED',
          style: properties?.claimed?.style || {},
        };
      case (allowTcCredits && tcCreditAmount > 0 && (tcCreditAmountType === 'PERCENTAGE' || tcCreditAmountType === 'VALUE')): {
        const amountText = tcCreditAmountType === 'PERCENTAGE'
          ? `Up to ${formatReadableNumber(tcCreditAmount * 100)}%`
          : `Up to $${formatReadableNumber(tcCreditAmount)}`;
        return {
          label: `${properties?.shopAndEarn?.label} ${amountText}`,
          style: properties?.shopAndEarn?.style || {},
        };
      }
      case (
        expireAt && !isPastDate(expireAt)
        && isSoonDate(expireAt, properties?.ending?.endingDays)
      ):
        return {
          label: formatExpirationDate({ date: expireAt, label: properties?.ending?.label }),
          style: properties?.ending?.style || {},
        };
      case isNew:
        return {
          label: properties?.new?.label || 'NEW',
          style: properties?.new?.style || {},
        };
      case isFreeReward:
        return {
          label: properties?.free?.label || '',
          style: properties?.free?.style || {},
        };

      case (Number(exchangeValue) <= properties?.flaggedValue?.exchangeValueFlagged):
        return {
          label: `${properties?.flaggedValue.label}${exchangeValue}`,
          style: properties?.flaggedValue?.style || {},
        };
      default:
        return {};
    }
  }, [status,
    isNew,
    isFreeReward,
    hasRewardCodes,
    exchangeValue,
    expireAt,
    properties,
    allowTcCredits,
    tcCreditAmount,
    tcCreditAmountType,
  ]);

  if (!label) {
    return null;
  }

  return (
    <div className={classNames('RewardFlag', { appliesMultiplier })} style={{ ...style }}>
      <p>{label}</p>
    </div>
  );
};

export default Flag;
